import { useState, useEffect } from "react";
import { Eye, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Toggling watchlist button: shows "Add to Watchlist" or "Remove from Watchlist" and toggles.
export default function WatchlistButton({ itemType, itemId, data, className = "" }) {
  const { user } = useAuth();
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user || !itemId) return;
    api.get("/watchlist")
      .then((r) => setSaved(r.data.some((w) => w.item_type === itemType && w.item_id === itemId)))
      .catch(() => {});
  }, [user, itemId, itemType]);

  const toggle = async () => {
    if (!user) { toast.error("Sign in to save"); return; }
    if (busy) return;
    setBusy(true);
    try {
      if (saved) {
        await api.delete(`/watchlist/${itemType}/${encodeURIComponent(itemId)}`);
        setSaved(false); toast.success("Removed from watchlist");
      } else {
        await api.post("/watchlist", { item_type: itemType, item_id: itemId, data });
        setSaved(true); toast.success("Added to watchlist");
      }
    } catch { toast.error("Could not update watchlist"); }
    finally { setBusy(false); }
  };

  return (
    <Button
      onClick={toggle}
      disabled={busy}
      variant={saved ? "default" : "outline"}
      data-testid="watchlist-button"
      data-saved={saved}
      className={`rounded-full ${className}`}
    >
      {saved ? <><Check className="w-4 h-4 mr-2" />Remove from Watchlist</> : <><Eye className="w-4 h-4 mr-2" />Add to Watchlist</>}
    </Button>
  );
}
